
export enum FiveLevelStateOfUse {
  Critical= 'Critical',
  Poor= 'Poor',
  Fair= 'Fair',
  Good= 'Good',
  Excellent= 'Excellent',

}